import * as React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";

class EmployeeMasterSearchComponent extends React.Component<any> {

    handleSearchValue = () => {
        var userName = document.getElementById('userName') as HTMLInputElement;
        this.props.handleSearchValue(userName.value, "")
    };

    render() {
        return (
            <div>
                <div className='trapezoid trapezoid-purple' style={{ width: '200px', display: 'inline-block' }}>
                    <span>Search menu</span>
                </div>
                <div className="mat-box shadow p-3 mb-5 bg-white rounded">
                    <Row>
                        <Col sm={8}>
                            <Form.Group className="mb-3" controlId="userName">
                                <Form.Label>User</Form.Label>
                                <Form.Control type="text" size="sm" placeholder="Enter User" />
                            </Form.Group>
                        </Col>
                        <Col lg={{ span: 2, offset: 2 }}>
                            <div className="mb-3 w-100 mt-4 d-flex justify-content-end">
                                <Button variant="info" size="sm" className="mx-1 btn btn-block" onClick={this.handleSearchValue}>
                                    <FaSearch /> Search
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

export default EmployeeMasterSearchComponent
